import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { ArrowDownOutlined, EditOutlined } from '@ant-design/icons'
import { DeleteIcon } from 'assets/icons'
import numeral from 'numeral'
import { hasPerms } from 'utils'

// table 数据源
export const getPreplotDataSource = paginatedData => {
    if (!paginatedData) return [{}]
    return paginatedData.data.records.map(item => ({
        id: item.id,
        fileName: item.fileName,
        fileType: item.fileType,
        fileSize: String(numeral((Number(item.fileSize) / 1024).toFixed(0)).format('0,0')) + ' KB',
        lineSum: numeral(item.lineSum).format('0,0'),
        pointSum: numeral(item.pointSum).format('0,0'),
        fileRow: numeral(item.fileRow).format('0,0'),
        coordinateSystem: item.coordinateSystem,
        updateTime: item.updateTime,
        createTime: item.createTime,
    }))
}

// 表头
export const usePreplotColumns = (
    handleEditClick,
    setDeleteId,
    downPreplotFileClick,
    setMultipleFlag
) => {
    const { t } = useTranslation()
    let columns = [
        {
            title: t('common.sNumber'),
            width: 60,
            render: (text, record, index) => `${index + 1}`,
            fixed: 'left',
        },
        {
            title: t('Preplot.fileName'),
            dataIndex: 'fileName',
            width: 300,
            sorter: (a, b) => {
                return a.fileName?.toLowerCase().localeCompare(b.fileName)
            },
        },
        {
            title: t('Preplot.lineSum'),
            dataIndex: 'lineSum',
            width: 140,
            className: 'keepRight',
            sorter: (a, b) => {
                return String(a.lineSum)?.toLowerCase().localeCompare(String(b.lineSum))
            },
        },
        {
            title: t('Preplot.pointSum'),
            dataIndex: 'pointSum',
            width: 140,
            className: 'keepRight',
            sorter: (a, b) => {
                return String(a.pointSum)?.toLowerCase().localeCompare(String(b.pointSum))
            },
        },
        {
            title: t('Preplot.fileRow'),
            dataIndex: 'fileRow',
            width: 140,
            className: 'keepRight',
            sorter: (a, b) => {
                return String(a.fileRow)?.toLowerCase().localeCompare(String(b.fileRow))
            },
        },
        {
            title: t('Preplot.fileSize'),
            dataIndex: 'fileSize',
            width: 140,
            className: 'keepRight',
            sorter: (a, b) => {
                return String(a.fileSize)?.toLowerCase().localeCompare(String(b.fileSize))
            },
        },
        {
            title: t('Preplot.wklist'),
            dataIndex: 'coordinateSystem',
            width: 200,
            className: 'keepRight',
            render: (text, record, index) => `${text}`,
            sorter: (a, b) => {
                return String(a.coordinateSystem)?.toLowerCase().localeCompare(String(b.coordinateSystem))
            },
        },
        {
            title: t('Preplot.createTime') + ' (UTC)',
            dataIndex: 'createTime',
            width: 200,
            className: 'keepRight',
            sorter: (a, b) => {
                return String(a.createTime)?.toLowerCase().localeCompare(String(b.createTime))
            },
        },
        {
            title: t('Preplot.updateTime') + ' (UTC)',
            dataIndex: 'updateTime',
            width: 200,
            className: 'keepRight',
            sorter: (a, b) => {
                return String(a.updateTime)?.toLowerCase().localeCompare(String(b.updateTime))
            },
        },
        {
            title: t('common.operate'),
            valueType: 'option',
            width: 60,
            fixed: 'right',
            render: (...arg) => {
                return (
                    <div className='operation' onClick={() => {}}>
                        <Tooltip title={t('common.edit')}>
                            <EditOutlined
                                className='edit'
                                hidden={hasPerms('setting:geometry:edit')}
                                onClick={() => {
                                    handleEditClick(arg[1].id)
                                    setMultipleFlag(false)
                                }}
                            />
                        </Tooltip>
                        <Tooltip title={t('common.download')}>
                            <ArrowDownOutlined
                                className='edit'
                                onClick={() => downPreplotFileClick(arg[1].id, arg[1].fileName)}
                            />
                        </Tooltip>
                        <Tooltip title={t('common.delete')}>
                            <DeleteIcon
                                className='delete'
                                hidden={hasPerms('setting:geometry:remove')}
                                onClick={() => setDeleteId(arg[1].id)}
                            />
                        </Tooltip>
                    </div>
                )
            },
        },
    ]
    return columns
}
